import React, { useState } from 'react'
import { Button } from 'antd'
import config from '../../../../config.json'
import $t from '../../../../i18n'
import { isMobileWeb } from '../../../../utils/detectMobileWeb'
import { useDispatch } from 'react-redux'
import Actions from '../../../../actions'
import AppDownloadConfirmationDialog from '../../dialogs/AppDownloadConfirmationDialog'
import Page from '../../../common/Page'

import './MobileWebUserBlocker.css'

const MobileWebUserBlocker = () => {
  const dispatch = useDispatch()

  const handleDownload = () => {
    if (isMobileWeb()) {
      window.open(config.downloadAppForMobile, '_blank')
    } else {
      dispatch(Actions.createAction(Actions.SHOW_APP_DOWNLOAD_LINK_POP_UP))
    }
    setTimeout(() => {
      dispatch(Actions.createAction(Actions.ENABLE_DOWNLOAD_LINK_BUTTON))
    }, 10000)
  }

  return (
    <Page
      className="block-page"
      title={$t('pages.getStarted.mobileWebUserBlocker.titleText')}
      subtitle={
        <>
          {$t('pages.getStarted.mobileWebUserBlocker.description1')}
          <br />
          {$t('pages.getStarted.mobileWebUserBlocker.description2')}
        </>
      }
    >
      <div className="block-mobile-web-page-container">
        <AppDownloadConfirmationDialog />
        <Button onClick={handleDownload} type="primary">
          {$t('pages.getStarted.mobileWebUserBlocker.downloadMobile')}
        </Button>
      </div>
    </Page>
  )
}

export default MobileWebUserBlocker
